<article class="store-card" [class.store-card--disabled]="disabled" [class.store-card--active]="inCart">
  <div class="store-card__media">
    <span class="store-card__flag" *ngIf="lowStock && !outOfStock">
      {{ 'clicStore.lastUnits' | translate }}
    </span>
    <img class="store-card__image" [src]="imageSrc" [alt]="product.name" (error)="onImageError($event)">
  </div>

  <div class="store-card__body">
    <p class="store-card__category" *ngIf="categoryLabel">{{ categoryLabel }}</p>
    <h2 class="store-card__name" [title]="product.name">{{ product.name }}</h2>

    <p class="store-card__stock" [class.store-card__stock--out]="outOfStock">
      <ng-container *ngIf="!outOfStock">
        {{ 'clicStore.stock' | translate }}: {{ stock }} {{ 'clicStore.unitsShort' | translate }}
      </ng-container>
      <ng-container *ngIf="outOfStock">{{ 'clicStore.unavailable' | translate }}</ng-container>
    </p>

    <p class="store-card__price">
      <strong class="store-card__price-value">{{ value | number }}</strong>
      <span class="store-card__price-unit">
        {{ (value === 1 ? 'clicStore.pointUnitSingular' : 'clicStore.pointsUnit') | translate }}
      </span>
    </p>

    <div class="store-card__action">
      <!-- Fora do carrinho: um botao unico. Dentro: stepper, para o usuario
           sempre conseguir DIMINUIR mesmo sem saldo para mais uma unidade. -->
      <button *ngIf="!inCart" type="button" class="store-card__add" [disabled]="disabled"
        (click)="add.emit(product)">
        <ng-container *ngIf="outOfStock">{{ 'clicStore.unavailable' | translate }}</ng-container>
        <ng-container *ngIf="!outOfStock && insufficient">
          {{ 'clicStore.notEnoughPoints' | translate }}
        </ng-container>
        <ng-container *ngIf="!disabled">+ {{ 'clicStore.addToCart' | translate }}</ng-container>
      </button>

      <div class="store-card__stepper" *ngIf="inCart">
        <button type="button" class="store-card__step" (click)="decrement.emit(product)"
          [attr.aria-label]="('clicStore.decreaseOf' | translate) + ' ' + product.name">&minus;</button>
        <span class="store-card__qty">{{ quantity }}</span>
        <button type="button" class="store-card__step" (click)="increment.emit(product)"
          [disabled]="!canIncrement" [attr.aria-describedby]="limitReason ? 'limit-' + product.id : null"
          [attr.aria-label]="('clicStore.increaseOf' | translate) + ' ' + product.name">+</button>
        <span class="store-card__in-cart" *ngIf="!limitReason">
          {{ 'clicStore.inCart' | translate }}
        </span>
        <!-- Motivo do bloqueio visivel, nao so em title: title nao chega a
             teclado nem a toque. -->
        <span class="store-card__limit" *ngIf="limitReason" [id]="'limit-' + product.id">
          {{ limitReason | translate }}
        </span>
      </div>
    </div>
  </div>
</article>
